
<template>
  <div>
    <template v-if="!wapShow">
      <headers :menuIndex="7"></headers>
      <div class="dataCenter-box">
        <div class="app-content">
          <ul class="tab-ul">
            <li class="tab-li" v-for="item in tabList" @click="tabIndex=item.categoryCode,selectIndex1=1,init()" :class="{'select':tabIndex==item.categoryCode}" :key="item.id">{{item.categoryName}}</li>
          </ul>
          <div style="margin: 20px 0;display: flex">
            <el-input v-model="name" placement="请输入关键词查询" style="width: 240px"></el-input>
            <el-button class="btn1" style="background:linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);border: 0;margin-left: 16px;height: 40px" type="primary" @click="searchName">搜索</el-button>
          </div>
          <div class="box-center">
            <template v-if="tabIndex=='code1'&&dataList.length>0">
              <!--技术问答-->
              <el-collapse>
                <el-collapse-item v-for="item in dataList" :name="item.id" style="margin-bottom: 20px">
                  <template slot="title">
                    <div class="text1"><i class="header-icon el-icon-question" style="margin-right: 10px;color: red "></i>{{item.name}}</div>
                  </template>
                  <div class="detail"><i class="header-icon el-icon-success" style="margin-right: 10px;color: #2C68FF;font-size: 20px"></i>{{item.description}}</div>
                  <div class="time">时间：{{item.createDate}} </div>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-else-if="tabIndex=='code4'&&dataList.length>0">
              <div class="box2">
                <div class="box2-li" v-for="item in dataList" :key="item.id" @click="videoUrl=item.fileUrl,videoShow=true">
                  <img src="@/assets/imgs/common/logo.png"  />
                  <div class="box2-title">
                    <p class="sp1"> {{item.name}}</p>
                    <p class="sp2">{{item.createDate.substring(0,10)}}</p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="boxs" v-if="dataList.length>0">
                <div class="boxs-li" v-for="item in dataList" :key="item.id" @click="toPage(item.fileUrl)">
                  <a :href="item.fileUrl"><i class="el-icon-download downloadClass"></i></a>
                  <div class="boxs-title">
                    <p class="sp1" :title="item.name"> {{item.name}}</p>
                    <p class="sp2" :title="item.description">{{item.description}}</p>
                    <p class="sp3">时间：{{item.createDate}}</p>
                  </div>
                </div>
              </div>

            </template>
            <div class="nodata" v-show="dataList.length==0">
              <img src="@/assets/imgs/noData.png"/>
              <span style=" display: block;">暂无您要搜索的内容，请与我们联系，我们将尽快为您处理。<span style="color: rgb(44, 104, 255) ;cursor: pointer" @click="toMessage">立即留言</span></span>
            </div>

          </div>
          <page style="margin-top: 40px" :selectIndex="selectIndex1" :pageIndex="pageIndex1" @last="selectIndex1--,getDataList()" @next="selectIndex1++,getDataList()"></page>
        </div>
       </div>
      <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>


    <div class="video-box" v-if="videoShow">
      <div class="video-box-bg" @click="videoShow=false"></div>
      <video :src="videoUrl" controls autoplay></video>
    </div>
  </div>
</template>


<script type="text/javascript">
  import page from "@/components/page"
  import headers from "@/components/header1"
  import footers from "@/components/footers"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../dataCenter/wapIndex";
  import axios from "axios";

  export default {
    name: 'dataCenter',
    components:{headers,footers,wapIndex,page},
    data(){
      return{
        wapShow:false,
        tabList:[],
        tabIndex:"",
        selectIndex1:1,
        pageIndex1:1,
        dataList:[],
        videoUrl:"",
        videoShow:false,
        name:""
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
      });
      this.getTabList();
    },
    methods:{
      toPage(url){
        window.open(url)
      },
      //下载文件
      downloadFile(data){

      },
      // 搜索
      searchName(){
        this.selectIndex1=1
        this.dataList=[];
        this.getDataList()
      },
      toMessage(){
        eventBus.$emit("contactUsShow",true)
      },
      getTabList(){
        axios.get(this.pageUrl+`/attachment-category/list?categoryCode=&categoryName=`).then(res=>{
          if(res.data.data.length>0){
            this.tabIndex=res.data.data[0].categoryCode;
            this.getDataList()
            this.tabList=res.data.data;
          }
        })
      },

      init(){
        this.selectIndex1=1;
        this.pageIndex1=1;
        this.dataList=[];
        this.getDataList()
      },

      //获取详细文件
      getDataList(){
        axios.get(this.pageUrl+`/attachment/page?categaryCode=${this.tabIndex}&pageNo=${this.selectIndex1}&pageSize=8&name=${this.name}`).then(res=>{
          if(res.data.data.list.length>0){
            this.pageIndex1=res.data.data.pages;
            this.dataList= res.data.data.list;
          }
        })
      }
    }

  }
</script>
<style>
  .el-collapse-item__header{
    height: auto !important;
    min-height: 40px;
  }
</style>
<style scoped>
  .nodata{
    text-align: center;
    font-size: 18px;
  }
  .nodata img{
    width: 400px;
  }
  .video-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video-box-bg{
    background: rgba(14, 14, 14, 0.78);
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .video-box video{
    width: 700px;
    height: 400px;
    position: relative;
    z-index: 4;
  }
  .box2{
    display: grid;
    grid-template-columns: repeat(auto-fill,386px);
    grid-column-gap:20px;
    grid-row-gap:20px;
    grid-template-rows:repeat(auto-fill,330px);
  }
  .box2 .box2-li{
    background: #ffffff;
    border-radius: 5px;
    overflow: hidden;
  }
  .box2-li img:hover{
    transform: scale(1.2);
  }
  .box2-li img{
    width: 60%;
    cursor: pointer;
    margin: 0 auto;
    display: block;
    height: 260px;
    object-fit: contain;
    transition: all 0.5s ease-in-out;
  }
  .box2-li .box2-title{
    padding: 8px 20px;
    border-top: 1px solid #eae6e6;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
  }
  .box2-li:hover{
    color: #2C68FF;
  }
  .box2-li .box2-title .sp1{
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    letter-spacing: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box2-li .box2-title .sp2{
    font-size: 12px;
    margin-top: 5px;
  }
  .box-center{
    margin-top: 40px;
    min-height: 500px;
  }
  .box-center .text1{
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    letter-spacing:4px;
    padding: 0 20px;
  }
  .box-center .detail{
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    padding: 20px 20px 0;
    letter-spacing: 2px;
  }
  .box-center .time{
    font-size: 12px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    padding: 10px 20px 0 50px;
  }
  .dataCenter-box{
    margin-top: 80px;
    background-color: #F2F4F9;
    padding: 40px 0;
  }
  .dataCenter-box .tab-ul{
    display: flex;
  }
  .dataCenter-box .tab-ul .tab-li{
    width: 200px;
    height: 60px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    border-radius: 10px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    cursor: pointer;
    font-size: 24px;
    letter-spacing: 4px;
  }
  .dataCenter-box .tab-ul .tab-li:hover{
    color: #2d87e5;
  }
  .dataCenter-box .tab-ul .tab-li.select{
    background: linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);
    color: #ffffff;
    font-weight: bold;
  }

  .boxs{
    display: grid;
    grid-template-columns: repeat(auto-fill,580px);
    grid-column-gap:20px;
    grid-row-gap:20px;
    grid-template-rows:repeat(auto-fill,160px);
  }

  .boxs .boxs-li{
    background: #ffffff;
    padding: 10px 20px;
    height: 160px;
    box-sizing: border-box;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
  }
  .boxs .boxs-li:hover{
    color: #2C68FF;
  }
  .boxs .boxs-li .downloadClass{
    position: absolute;
    font-size: 30px;
    right: 20px;
    top: 15px;
    cursor: pointer;
    color: #313131;
  }
  .boxs .boxs-li .downloadClass:hover{
    color: #2C68FF;
  }
  .boxs .boxs-li .sp1{
    font-size: 20px;
    font-weight: bold;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    letter-spacing: 4px;
    width: 90%;
  }
  .boxs .boxs-li .sp2{
    font-size: 14px;
    overflow: hidden;
    width: 80%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-height: 2;
    margin-top: 10px;
    -webkit-box-orient: vertical;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  }
  .boxs .boxs-li .sp3{
    color: #908989;
    font-size: 12px;
    margin-top: 10px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  }
</style>



// WEBPACK FOOTER //
// src/view/dataCenter/index.vue